<template>
    <div class="form">
        <!--步骤条-->
        <steps :active="active" :isUpload="isUpload" :emsNeeded="matterInfo.emsNeeded"></steps>
        <!--第一页（申报信息）-->
        <div v-show="active === 0">
            <!--公安机关选择-->
            <select-police :matterInfo="matterInfo" :declareInfo="declareInfo" ref="selectpolice"
                           :informationShowData="informationShowData"></select-police>
            <!--基本信息-->
            <p class="title">申请人信息</p>
            <van-cell-group>
                <van-field required label="社会福利机构名称" v-model="body.data.shfljgmc" input-align="right"/>
                <!--社会福利机构省-->
                <van-field required v-model="agencyProvince" label="社会福利机构地址" placeholder="请选择省份" is-link readonly
                           input-align="right"
                           @click="showAgencyProvince = true"/>
                <van-popup v-model="showAgencyProvince" position="bottom">
                    <van-picker :columns="provinceList" show-toolbar value-key="title"
                                @cancel="showAgencyProvince = false"
                                @confirm="onConfirmAgencyProvince"/>
                </van-popup>
                <!--社会福利机构市-->
                <van-field v-model="agencyCity" placeholder="请选择市区" is-link readonly input-align="right"
                           @click="showAgencyCity = true" v-if="agencyCityShow"/>
                <van-popup v-model="showAgencyCity" position="bottom">
                    <van-picker :columns="cityList" show-toolbar value-key="title" @cancel="showAgencyCity = false"
                                @confirm="onConfirmAgencyCity"/>
                </van-popup>
                <!--社会福利机构区县-->
                <van-field v-model="agencyArea" placeholder="请选择区县" is-link readonly input-align="right"
                           @click="showAgencyArea = true" v-if="agencyAreaShow"/>
                <van-popup v-model="showAgencyArea" position="bottom">
                    <van-picker :columns="areaList" show-toolbar value-key="title" @cancel="showAgencyArea = false"
                                @confirm="onConfirmAgencyArea"/>
                </van-popup>
                <van-field input-align="right" type="textarea" required
                           v-model="jgdz"
                           placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
                <!--申请人姓名-->
                <van-field required label="申请人姓名" :value="body.sqrxm" input-align="right" readonly/>
                <!--申请人性别-->
                <van-field required readonly clickable label="性别" input-align="right" is-link
                           :value="sex" placeholder="请选择"
                           @click="showPickerSex = true"/>
                <van-popup v-model="showPickerSex" position="bottom">
                    <van-picker show-toolbar :columns="columnsSex" value-key="title" @cancel="showPickerSex = false"
                                @confirm="onConfirmSex"/>
                </van-popup>
                <!--申请人出生日期-->
                <van-field required readonly clickable label="出生日期" input-align="right" is-link
                           :value="body.data.csrq"
                           placeholder="请选择"
                           @click="showPickerBirthDate = true"/>
                <van-popup v-model="showPickerBirthDate" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"
                                         @cancel="showPickerBirthDate = false" @confirm="onConfirmBirthdayDate"/>
                </van-popup>
                <!--申请人公民身份号码-->
                <van-field required label="公民身份号码" input-align="right"
                           :value="body.sqrgmsfhm.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2')"
                           readonly/>
                <!--申请人联系电话-->
                <van-field required label="联系电话" input-align="right" v-model="body.sqrlxfs"
                           placeholder="请输入联系电话" clearable/>
            </van-cell-group>
            <!--定制化表单-->
            <p class="title">填报申请信息</p>
            <!--拟落户人姓名-->
            <van-field required label="拟落户人姓名" v-model="body.data.nlhr_xm" placeholder="请输入拟落户人姓名"
                       input-align="right" clearable/>
            <!--拟落户人性别-->
            <van-field required readonly clickable label="性别" input-align="right" is-link
                       :value="sex_nlhr" placeholder="请选择"
                       @click="showNlhrPickerSex = true"/>
            <van-popup v-model="showNlhrPickerSex" position="bottom">
                <van-picker show-toolbar :columns="columnsSex" value-key="title" @cancel="showNlhrPickerSex = false"
                            @confirm="onConfirmNlhrSex"/>
            </van-popup>
            <!--拟落户人民族-->
            <van-field required readonly clickable label="民族" is-link input-align="right"
                       :value="mz" placeholder="请选择"
                       @click="showPickerNation = true"/>
            <van-popup v-model="showPickerNation" position="bottom">
                <van-picker show-toolbar :columns="nationList" value-key="title" @cancel="showPickerNation = false"
                            @confirm="onConfirmNation"/>
            </van-popup>
            <!--拟落户人出生日期-->
            <van-field required readonly clickable label="出生日期" input-align="right" is-link
                       :value="body.data.nlhr_csrq"
                       placeholder="请选择"
                       @click="showNlhrPickerBirthDate = true"/>
            <van-popup v-model="showNlhrPickerBirthDate" position="bottom">
                <van-datetime-picker v-model="currentDate1" type="date" :max-date="maxDate" :min-date="minDate"
                                     @cancel="showNlhrPickerBirthDate = false" @confirm="onConfirmNlhrBirthdayDate"/>
            </van-popup>
            <!--籍贯国家-->
            <van-field required v-model="nativeCountry" label="籍贯" placeholder="请选择国家" is-link readonly
                       input-align="right" @click="showNativeCountry = true"/>
            <van-popup v-model="showNativeCountry" position="bottom">
                <van-picker :columns="countryList" show-toolbar value-key="name" @cancel="showNativeCountry = false"
                            @confirm="onConfirmNativeCountry"/>
            </van-popup>
            <!--籍贯省-->
            <van-field v-model="nativeProvince" placeholder="请选择省份" is-link readonly input-align="right"
                       @click="showNativeProvince = true" v-if="nativeProvinceShow"/>
            <van-popup v-model="showNativeProvince" position="bottom">
                <van-picker :columns="provinceList" show-toolbar value-key="title" @cancel="showNativeProvince = false"
                            @confirm="onConfirmNativeProvince"/>
            </van-popup>
            <!--籍贯市-->
            <van-field v-model="nativeCity" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showNativeCity = true" v-if="nativeCityShow"/>
            <van-popup v-model="showNativeCity" position="bottom">
                <van-picker :columns="cityList" show-toolbar value-key="title" @cancel="showNativeCity = false"
                            @confirm="onConfirmNativeCity"/>
            </van-popup>
            <!--籍贯区县-->
            <van-field v-model="nativeArea" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showNativeArea = true" v-if="nativeAreaShow"/>
            <van-popup v-model="showNativeArea" position="bottom">
                <van-picker :columns="areaList" show-toolbar value-key="title" @cancel="showNativeArea = false"
                            @confirm="onConfirmNativeArea"/>
            </van-popup>
            <!--与申请人关系-->
            <van-field required readonly clickable label="与申请人关系" input-align="right" is-link
                       :value="sqrgx" placeholder="请选择" @click="showPickerRelation = true"/>
            <van-popup v-model="showPickerRelation" position="bottom">
                <van-picker show-toolbar :columns="relationList" value-key="title" @cancel="showPickerRelation = false"
                            @confirm="onConfirmRelation"/>
            </van-popup>
            <!--拟落户省-->
            <van-field required v-model="nlhProvince" label="拟落户地址" placeholder="请选择省份" is-link readonly
                       input-align="right"
                       @click="showNlhProvince = true"/>
            <van-popup v-model="showNlhProvince" position="bottom">
                <van-picker :columns="provinceLHList" show-toolbar value-key="title" @cancel="showNlhProvince = false"
                            @confirm="onConfirmNlhProvince"/>
            </van-popup>
            <!--拟落户市区-->
            <van-field v-model="nlhCity" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showNlhCity = true" v-if="nlhCityShow"/>
            <van-popup v-model="showNlhCity" position="bottom">
                <van-picker :columns="cityList" show-toolbar value-key="title" @cancel="showNlhCity = false"
                            @confirm="onConfirmNlhCity"/>
            </van-popup>
            <!--拟落户县区-->
            <van-field v-model="nlhArea" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showNlhArea = true" v-if="nlhAreaShow"/>
            <van-popup v-model="showNlhArea" position="bottom">
                <van-picker :columns="areaList" show-toolbar value-key="title" @cancel="showNlhArea = false"
                            @confirm="onConfirmNlhArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" required
                       v-model="nlhdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <div class="btn-submit-div btn-submit-back">
                <van-button type="info" size="large" @click="next(1)">下一步</van-button>
            </div>
        </div>
        <!--第二页（附件上传）-->
        <div v-show="active === 1" v-if="isUpload">
            <p class="title">附件上传
                <span class="text-danger">
                    (注:材料图片应展现全貌、清晰可辨。应户政要求，照片大小不超过1MB，为避免无法正常提交，请使用微信拍照图片上传。)
                </span>
            </p>
            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">
                <upload-image :title="item.itemName" :required="item.requred === 'Y'"
                              :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"
                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData"
                              @setImageInfo="getImageInfo"
                              @setIsImages="getIsImages"></upload-image>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>
            </div>
        </div>
        <!-- 第三页（办理方式）-->
        <div v-show="active === 2">
            <!--邮寄信息-->
            <mailing @setNextUpShow="getNextUpShow" :matterInfo="matterInfo" :declareInfo="declareInfo"
                     v-if="matterInfo.emsNeeded === 'Y'"
                     ref="mailingChildFunction"
                     @setMailingData="getMailingData" @getStatus="getStatus"></mailing>
            <div class="btn-submit-div-double" v-if="nextUpShow">
                <van-button class="btn-left" type="info" size="large" @click="up(1)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(3)">下一步</van-button>
            </div>
        </div>
        <!--第四页（提交确认）-->
        <div v-show="active === 3">
            <!--展示信息-->
            <information-show :informationShowData="informationShowData" :showPropList="baseInfoList"
                              @setActive="getActive"></information-show>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo'
                            @click="matterInfo.emsNeeded === 'Y'?up(2):up(1)">上一步
                </van-button>
                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Description: 标准事项
     * Author: wangyan
     * Date: 2019-04-23
     * Time: 15:17
     */

    import {Button, Toast, CellGroup, Dialog, Cell, Field, Popup, Picker, DatetimePicker} from 'vant'
    import {matterApiMap} from '@/api/matter'
    import Steps from "@/components/declare/Steps"
    import SelectPolice from "@/components/declare/SelectPolice"
    import UploadImage from "@/components/upload-image/UploadImage"
    import Mailing from "@/components/declare/Mailing"
    import InformationShow from "@/components/custom/InformationShow";
    // import CustomForm from './custom/CustomForm';
    import {taskApiMap} from "@/api/task";
    import {baseApiMap} from '@/api/base'
    import {dateToString} from '@/utils/time'
    import {idCardRegex} from '@/utils/regex'

    export default {
        name: "StandardMatter",
        components: {
            InformationShow,
            Mailing,
            UploadImage,
            Steps,
            SelectPolice,
            // CustomForm,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Dialog.name]: Dialog,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                provinceLHList: [{ "title": '湖北省', "val": '420000' }], // 拟落户省
                provinceList: [], // 省
                cityList: [], // 市
                areaList: [], // 区县
                list: [],
                columnsSex: [], // 性别集合
                nationList: [], // 民族集合
                baseInfoList: [], // 展示组件展示的基本信息

                flag: '', //办理方式传过来的状态
                active: 0, // 控制步骤条当前位置
                matterInfo: {}, // 存放事项信息
                isUpload: false, // 判断是否有附件上传
                userInfo: {}, // 存放个人信息
                path: global.storageUrl + '/storage/upload', // 上传图片的地址
                isImagesList: [], // 存放每组上传图片是否已经上了
                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏
                informationShowData: { // 展示信息
                    deptName: '', // 公安机关中文名（展示信息）
                    name: '', // 姓名（展示信息）
                    idNum: '', // 身份证（展示信息）
                    sqrSex: '', // 申请人性别（展示信息）
                    sqrCsrq: '', //申请人出生日期(展示信息)
                    sqrGmsfhm: '', //申请人公民身份号码(展示信息)
                    address: '',//联系地址（展示信息）
                    agencyName: '',//机构名称（展示信息）
                    agencyAddress: '', // 机构地址（展示信息）
                    nlhAddress: '', // 机构地址（展示信息）
                    phone: '', // 联系方式（展示信息）
                    relation: '', // 拟落户人与申请人关系（展示信息）
                    nlhrName: '',//拟落户人姓名（展示信息）
                    nlhrSex: '',//拟落户人性别（展示信息）
                    nlhrNation: '',//拟落户人民族（展示信息）
                    nlhrCsrq: '',//拟落户人出生日期（展示信息）
                    nlhrJg: '',//拟落户人籍贯（展示信息）
                    isUpload: false, // 是否有附件上传状态（展示信息）
                    imageTitleList: [], // 附件标题列表（展示信息）
                    imageList: [], // 附件列表（展示信息）
                    mailingShow: '', // 是否有邮寄信息状态（展示信息）
                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件
                    takeData: {}, // 取件信息（展示信息）
                    takePrice: '', // 取件费用（展示信息）
                    receiveData: {}, // 送件信息（展示信息）
                    receivePrice: '', // 送件费用（展示信息）
                    totalPrice: '', // 工本费（展示信息）

                },
                declareInfo: {
                    matNum: '', // 事项编号
                    deptId: '', // 所选公安部门id
                    linkAddress: '', // 联系地址
                    linkPhone: '', // 电话号码
                    netProjectType: 'WEI',  // 申报方式(PCP|WIN|WEI|WAP|APP)
                    tskSource: 'SYS', // 申报来源(写死)
                    isMailMertal: '0', // 邮寄方式 101：EMS邮寄线上支付
                    wfId: '', // 工作流id
                    manifests: [], // 存放附件信息
                    accountId: this.$cookie.getUser().acountId, // 注册的电话号码
                    addressGuidQj: '', // 邮寄地址上门Guid
                    addressGuidSh: '', // 邮寄地址送件Guid
                    qjMoney: '', // 取件费用
                    shMoney: '', // 收件费用
                    gbMoney: '', // 工本费
                    emsConfig: '', // 邮寄流程：1：办结送件，2：双程，3：上门取件

                },
                body: {
                    sqrxm: '',   //申报人姓名
                    sqrgmsfhm: '',  //申报人身份证
                    sqrlxfs: '', //申报人联系方式
                    sqrdz: '', //申报人联系地址
                    pcsmcbm: '', //派出所名称(受理机关)编号
                    pcsmc: '',//派出所名称(受理机关)
                    sxmc: '',//事项名称
                    sxmcid: '',//事项名称id
                    data: {
                        shfljgmc: '',
                        dz: '',
                        sqrxm: '',
                        xb: '',
                        csrq: '',
                        gmsfhm: '',
                        lxdh: '',
                        nlhr_xm: '',
                        nlhr_xb: '',
                        nlhr_csrq: '',
                        nlhr_jg: '',
                        nlhr_mz: '',
                        nlhr_ysqrgx: '',
                        nlhr_nlhdpcs:'',
                        nlhr_nlhdz: '',
                        sqly: '',
                    }

                },

                jgdz: '',//机构详细地址
                nlhdz: '',//拟落户地址
                mz: '', //民族
                sqrgx: '', //与申请人关系
                showPickerRelation: false, // 是否显示与拟落户人关系的选择框
                relationList: [], // 与拟落户人关系的集合
                currentDate: new Date(), // 申请人出生日期
                currentDate1: new Date(), // 拟落户人人出生日期
                maxDate: new Date(),
                minDate: new Date(1950, 1, 1),

                //社会福利机构
                agencyProvince: '',
                agencyCity: '',
                agencyArea: '',
                showAgencyProvince: false,
                showAgencyCity: false,
                showAgencyArea: false,
                agencyCityShow: false,
                agencyAreaShow: false,

                //出生地
                nativeCountry: '', // 出生地国家
                nativeProvince: '', // 出生地省
                nativeCity: '', // 出生地市
                nativeArea: '', // 出生地区县
                nativeProvinceShow: false, //显示籍贯省份
                nativeCityShow: false, // 显示选择出生地市
                nativeAreaShow: false, // 显示选择出生地区县
                showNativeCountry: false, // 是否显示出生地国家选择框
                showNativeProvince: false, // 是否显示出生地省选择框
                showNativeCity: false, // 是否显示出生地省选择框
                showNativeArea: false, // 是否显示出生地省选择框


                //拟落户地址
                nlhProvince: '', //拟落户地省
                nlhCity: '', //拟落户地市
                nlhArea: '', //拟落户地区县
                nlhCityShow: false, // 显示选择拟落户地城市
                nlhAreaShow: false, // 显示选择拟落户地区县
                showNlhProvince: false,  //是否显示拟落户地省
                showNlhCity: false,  //是否显示拟落户地市
                showNlhArea: false,  //是否显示拟落户地区县

                showPickerBirthDate: false, // 是否显示申请人出生日期选择框
                showNlhrPickerBirthDate: false, // 是否显示申请人出生日期选择框

                countryList: [{"id": "900156", "name": "中国"}], // 国家集合

                showPickerSex: false, // 是否显示申请人性别选择框
                showNlhrPickerSex: false, // 是否显示拟落户人性别选择框

                sex: '', // 申请人性别显示的名称
                sex_nlhr: '', //拟落户人性别显示的名称

                relation: '', //与拟落户人关系
                showPickerNation: false, // 是否显示民族选择框
            }
        },
        mounted() {
            this.getMatterInfo()
            this.getUserInfo()
            this.getProvinceData()
            this.getReservationSex()//加载性别
            this.getRelation()   //加载与你落户人关系
            this.getNation()     //加载民族
        },
        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览
            for (let index in this.$refs.imageChildFunction) {
                this.$refs.imageChildFunction[index].closePreview()
            }
            next()
        },
        methods: {
            /**
             * 选择的办理方式
             * status false:窗口办理 true:邮寄服务
             */
            getStatus(status) {
                this.flag = status
            },
            /**
             * 获取事项信息
             */
            async getMatterInfo() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)
                    this.matterInfo = res.data.data
                    this.declareInfo.matNum = res.data.data.matNum
                    if (this.matterInfo.manifests.length) {
                        this.isUpload = true
                        this.informationShowData.isUpload = true
                        this.informationShowData.imageTitleList = this.matterInfo.manifests
                    }
                    this.declareInfo.emsConfig = this.matterInfo.emsConfig
                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                    this.informationShowData.mailingStatus = this.matterInfo.emsConfig
                    this.declareInfo.wfId = this.matterInfo.wfId
                    this.body.sxmc = this.matterInfo.matName
                    this.body.sxmcid = this.matterInfo.matNum
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 获取个人信息
             */
            async getUserInfo() {
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province
                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city
                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area
                    let address = this.userInfo.address === null ? "" : this.userInfo.address
                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()
                    if (fullAddress === '0') {
                        fullAddress = '暂无'
                    }
                    this.userInfo.fullAddress = fullAddress
                    this.declareInfo.linkAddress = fullAddress
                    this.declareInfo.linkPhone = this.userInfo.telephone
                    this.informationShowData.phone = this.userInfo.telephone
                    this.informationShowData.address = fullAddress
                    this.informationShowData.name = this.userInfo.realName
                    this.informationShowData.idNum = this.userInfo.idNum
                    this.body.sqrxm = this.userInfo.realName
                    this.body.sqrlxfs = this.userInfo.telephone
                    this.body.sqrgmsfhm = this.userInfo.idNum
                    this.body.sqrdz = this.userInfo.fullAddress
                    this.body.data.sqrxm = this.userInfo.realName
                    this.body.data.lxdh = this.userInfo.telephone
                    this.body.data.gmsfhm = this.userInfo.idNum
                }
            },

            /**
             * 加载性别
             */
            getReservationSex() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {
                    let arr = [];
                    if (response.data.succ = true) {
                        var arrSex = response.data.data;
                        for (var i = 0; i < arrSex.length; i++) {
                            arr.push({"title": arrSex[i].title, "val": arrSex[i].val})
                        }
                    }
                    this.$nextTick(() => {
                        this.columnsSex = arr
                    })
                }).catch(err => {

                })
            },

            /**
             * 校验第一页表单信息
             */
            checkOneStep() {
                if (!this.body.data.shfljgmc) {
                    Toast('请输入社会福利机构名称')
                    return false;
                }
                if (!this.agencyProvince) {
                    Toast('请选择机构省份')
                    return false;
                }
                if (!this.agencyCity) {
                    Toast('请选择机构城市')
                    return false;
                }
                if (!this.agencyArea) {
                    Toast('请选择机构区县')
                    return false;
                }
                if (!this.jgdz) {
                    Toast('请输入机构详细地址')
                    return false;
                }
                if (!this.body.sqrxm) {
                    Toast('请输入申请人姓名')
                    return false;
                }
                if (!this.sex) {
                    Toast('请选择申请人性别')
                    return false;
                }
                if (!this.body.data.csrq) {
                    Toast('请选择申请人出生日期')
                    return false;
                }
                if (!this.body.sqrgmsfhm) {
                    Toast('请输入申请人身份证号')
                    return false;
                }
                if (this.body.data.gmsfhm && !idCardRegex(this.body.data.gmsfhm)) {
                    Toast('请输入正确的身份证号')
                    return false;
                }
                if (!this.body.sqrlxfs) {
                    Toast('请输入申请人联系电话')
                    return false;
                }
                if (!(/^1[3456789]\d{9}$/.test(this.body.sqrlxfs))) {
                    Toast('请输入正确的联系电话')
                    return false;
                }
                if (!this.body.data.nlhr_xm) {
                    Toast('请输入拟落户人姓名')
                    return false;
                }
                if (!(/^[\u4e00-\u9fa5]{2,4}$/.test(this.body.data.nlhr_xm))) {
                    Toast('请输入正确的拟落户人姓名')
                    return false;
                }
                if (!this.body.data.nlhr_xb) {
                    Toast('请选择拟落户人性别')
                    return false;
                }
                if (!this.body.data.nlhr_mz) {
                    Toast('请选择拟落户人民族')
                    return false;
                }
                if (!this.body.data.nlhr_csrq) {
                    Toast('请选择拟落户人出生日期')
                    return false;
                }
                if (!this.nativeCountry) {
                    Toast('请选择拟落户人籍贯国家')
                    return false;
                }
                if (!this.nativeProvince) {
                    Toast('请选择拟落户人籍贯省份')
                    return false;
                }
                if (!this.nativeCity) {
                    Toast('请选择拟落户人籍贯市')
                    return false;
                }
                if (!this.nativeArea) {
                    Toast('请选择拟落户人籍贯区县')
                    return false;
                }
                if (!this.body.data.nlhr_ysqrgx) {
                    Toast('请选择拟落户人与申请人关系')
                    return false;
                }
                if (!this.nlhProvince) {
                    Toast('请选择拟落户省份')
                    return false;
                }
                if (!this.nlhCity) {
                    Toast('请选择拟落户市')
                    return false;
                }
                if (!this.nlhArea) {
                    Toast('请选择拟落户区县')
                    return false;
                }
                if (!this.nlhdz) {
                    Toast('请选择拟落户的详细地址')
                    return false;
                }


                return true
            },

            /**
             * 下一页
             * @param index 传入每一页下标
             */
            next(index) {
                Toast.clear()
                if (index === 1) { // 申报信息页面验证
                    this.$refs.selectpolice.setDeptId() // 部门赋值
                    this.body.pcsmc = this.informationShowData.deptName
                    this.body.pcsmcbm = this.declareInfo.deptId
                    if (!this.declareInfo.deptId) {
                        Toast('请选择公安机关')
                        return
                    }

                    this.body.data.dz = this.agencyProvince + this.agencyCity + this.agencyArea + this.jgdz;
                    this.body.data.nlhr_nlhdz = this.nlhProvince + this.nlhCity + this.nlhArea + this.nlhdz;

                    // 申请人拟落户地址与受理公安机关一样
                    this.body.data.nlhr_nlhdpcs = this.informationShowData.allDeptName
                    this.informationShowData.agencyName = this.body.data.shfljgmc;
                    this.informationShowData.agencyAddress = this.body.data.dz;
                    this.informationShowData.sqrCsrq = this.body.data.csrq;
                    this.informationShowData.nlhAddress = this.body.data.nlhr_nlhdz
                    this.informationShowData.nlhrName = this.body.data.nlhr_xm;
                    this.informationShowData.sex = this.sex;
                    this.informationShowData.nlhrSex = this.sex_nlhr
                    this.informationShowData.nlhrNation = this.mz
                    this.informationShowData.nlhrCsrq = this.body.data.nlhr_csrq
                    this.informationShowData.nlhrJg = this.nativeProvince + this.nativeCity + this.nativeArea;
                    this.userInfo.fullAddress = this.body.sqrdz
                    this.declareInfo.linkAddress = this.body.sqrdz


                    //校验第一页表单信息
                    if (!this.checkOneStep()) {
                        return
                    }
                    if (this.isUpload) { // 根据是否有上传附件判断进入'附件上传'或'办理方式'
                        this.active = 1
                    } else if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        // 到第三页传值
                        this.sendCustomInfomation()
                        this.active = 3
                    }
                } else if (index === 2) { // 附件上传页面验证
                    this.declareInfo.manifests = []
                    this.informationShowData.imageList = []
                    this.isImagesList = []
                    for (let index in this.$refs.imageChildFunction) { // 上传图片赋值
                        this.$refs.imageChildFunction[index].passImageValue()
                    }
                    for (let index in this.isImagesList) { // 判断必上传的图片是否上传
                        if (!this.isImagesList[index]) {
                            Toast('请选择上传附件')
                            return
                        }
                    }
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        // 到第三页传值
                        this.sendCustomInfomation()
                        this.active = 3
                    }
                } else if (index === 3) {
                    this.$refs.mailingChildFunction.passMailingValue()
                    if (this.flag === false) { // false:窗口办理 true:邮寄服务
                        this.informationShowData.mailingShow = false
                        this.declareInfo.isMailMertal = '0'
                        // 到第三页传值
                        this.sendCustomInfomation()
                        this.active = 3
                    } else { // 邮寄服务
                        this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                        this.declareInfo.isMailMertal = '101' // 办理方式：'0'窗口办理，'101'邮寄

                        if (this.declareInfo.emsConfig === '3' && !this.declareInfo.addressGuidQj) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.emsConfig === '1' && !this.declareInfo.addressGuidSh) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.emsConfig === '2' && !this.declareInfo.addressGuidQj && !this.declareInfo.addressGuidSh) {
                            Toast('请至少选择一种邮寄方式')
                            return
                        }

                        if (this.declareInfo.addressGuidQj && this.declareInfo.addressGuidSh) {//两者都选
                            this.informationShowData.mailingStatus = '2'
                        } else if (this.declareInfo.addressGuidQj) { // 二选一
                            // 选择了取件地址
                            this.informationShowData.mailingStatus = '3'
                            this.declareInfo.addressGuidSh = ''
                        } else if (this.declareInfo.addressGuidSh) {
                            // 选择了收件地址
                            this.informationShowData.mailingStatus = '1'
                            this.declareInfo.addressGuidQj = ''
                        }
                    }
                    // 到第三页传值
                    this.sendCustomInfomation()
                    this.active = 3

                }
            },

            /**
             * 上一页
             * @param index 传入每一页下标
             */
            up(index) {
                console.log(index)
                if (index === 0) {
                    this.active = 0
                } else if (index === 1) {
                    this.active = 1
                } else if (index === 2) {
                    this.active = 2
                }
            },

            /**
             * 接收上传图片组件传来的image列表
             * @param value image列表
             */
            getImageInfo(value) {
                if (value.length > 0) {
                    for (let index in value) {
                        this.declareInfo.manifests.push(value[index])
                        this.informationShowData.imageList.push(value[index])
                    }
                }
            },

            /**
             * 接收是否上传图片的状态
             * @param value 是否上传了图片状态
             */
            getIsImages(value) {
                this.isImagesList.push(value)
            },

            /**
             * 接收邮寄信息组件传来的是否展示邮寄信息的'上一页'和'下一页'的状态
             * @param value 布尔值
             */
            getNextUpShow(value) {
                this.nextUpShow = value
            },

            /**
             * 接收邮寄信息组件
             * @param value 布尔值
             */
            getMailingData(value) {
                this.declareInfo.addressGuidQj = value.addressGuidQj
                this.declareInfo.addressGuidSh = value.addressGuidSh
                this.declareInfo.qjMoney = value.qjMoney
                this.declareInfo.shMoney = value.shMoney
                this.declareInfo.gbMoney = value.gbMoney
                this.informationShowData.takeData = value.takeData
                this.informationShowData.takePrice = value.qjMoney
                this.informationShowData.receiveData = value.receiveData
                this.informationShowData.receivePrice = value.shMoney
                this.informationShowData.totalPrice = value.gbMoney
            },

            /**
             * 接收事项信息展示组件传来的值，改变active参数
             * @param value 传来的下标，改变active参数
             */
            getActive(value) {
                this.active = value
            },
            /**
             * 提交时，需要把标准化事项和定制化事项的两个数据对象合并
             * @return {Promise<void>}
             */
            async submit() {
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })
                let data = {
                    taskApply: this.declareInfo,
                    body: this.body
                }
                try {
                    const res = await this.$httpUtils.postGatewayUtils(taskApiMap.hzTsks, data)
                    if (res.data.succ) {
                        Toast.clear()
                        if (this.informationShowData.mailingShow === 'Y') {
                            Dialog.alert({
                                title: '申报成功',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })

                        } else {
                            Dialog.alert({
                                title: '申报成功，预审通过后，您可以携带相关办件材料至窗口办理',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })
                        }

                    } else {
                        Toast.fail('申报失败')
                    }
                } catch (error) {
                    console.log(error)
                    Toast.clear()
                }
            },


            /**
             * 选择与申请人关系
             * @param value
             */
            onConfirmRelation(value) {
                this.sqrgx = value.title
                this.informationShowData.relation = value.title
                this.body.data.nlhr_ysqrgx = value.val
                this.showPickerRelation = false
            },
            /**
             * 选择申请人出生日期
             */
            onConfirmBirthdayDate(value) {
                this.body.data.csrq = dateToString(value, "yyyy-MM-dd")
                this.showPickerBirthDate = false
            },
            /**
             * 选择拟落户人出生日期
             */
            onConfirmNlhrBirthdayDate(value) {
                this.body.data.nlhr_csrq = dateToString(value, "yyyy-MM-dd")
                this.showNlhrPickerBirthDate = false
            },
            /**
             * 选择籍贯国家
             * @param value
             */
            onConfirmNativeCountry(value) {
                this.nativeCountry = value.name
                this.showNativeCountry = false
                this.nativeProvinceShow = true
            },
            /**
             * 获取省
             */
            async getProvinceData() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (var i = 0; i < d.length; i++) {
                            arr.push({"title": d[i].regionname, "val": d[i].regioncode})
                        }
                    }
                    this.provinceList = arr
                } catch (error) {
                    Toast('服务器运行失败')
                    console.log(error);
                }
            },
            /**
             * 获取市
             */
            async getCityData(value) {
                try {
                    this.cityList = []
                    this.areaList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (var i = 0; i < d.length; i++) {
                            arr.push({"title": d[i].regionname, "val": d[i].regioncode})
                        }
                    }
                    this.cityList = arr
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 获取地区
             */
            async getAreaData(value) {
                try {
                    this.areaList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (var i = 0; i < d.length; i++) {
                            arr.push({"title": d[i].regionname, "val": d[i].regioncode})
                        }
                    }
                    this.areaList = arr
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             *  机构省列表
             */
            onConfirmAgencyProvince(value, index) {
                this.agencyProvince = value.title
                this.showAgencyProvince = false
                this.agencyCity = ''
                this.agencyArea = ''
                this.agencyCityShow = true
                this.getCityData(value.val)
            },
            /**
             *  机构市列表
             */
            onConfirmAgencyCity(value, index) {
                this.agencyCity = value.title
                this.agencyArea = ''
                this.showAgencyCity = false
                this.agencyAreaShow = true
                this.getAreaData(value.val)
            },
            /**
             *  机构区县列表
             */
            onConfirmAgencyArea(value) {
                this.agencyArea = value.title
                this.showAgencyArea = false
            },
            /**
             *  籍贯省列表
             */
            onConfirmNativeProvince(value, index) {
                this.nativeProvince = value.title
                this.nativeCity = ''
                this.nativeArea = ''
                this.showNativeProvince = false
                this.nativeCityShow = true
                this.getCityData(value.val)
            },
            /**
             *  籍贯市列表
             */
            onConfirmNativeCity(value, index) {
                this.nativeCity = value.title
                this.nativeArea = ''
                this.showNativeCity = false
                this.nativeAreaShow = true
                this.getAreaData(value.val)
            },
            /**
             *  籍贯地区列表
             */
            onConfirmNativeArea(value, index) {
                this.nativeArea = value.title
                this.body.data.nlhr_jg = value.val
                this.showNativeArea = false
            },
            /**
             *  籍贯省列表
             */
            onConfirmNlhProvince(value, index) {
                this.nlhProvince = value.title
                this.nlhCity = ''
                this.nlhArea = ''
                this.showNlhProvince = false
                this.nlhCityShow = true
                this.getCityData(value.val)
            },
            /**
             *  籍贯市列表
             */
            onConfirmNlhCity(value, index) {
                this.nlhCity = value.title
                this.nlhArea = ''
                this.showNlhCity = false
                this.nlhAreaShow = true
                this.getAreaData(value.val)
            },
            /**
             *  籍贯地区列表
             */
            onConfirmNlhArea(value, index) {
                this.nlhArea = value.title
                // this.body.jgSsxqbm = value.val
                this.showNlhArea = false
            },
            /**
             * 选择申请人性别
             */
            onConfirmSex(value) {
                this.sex = value.title
                this.body.data.xb = value.val
                this.showPickerSex = false
            },
            /**
             * 选择拟落户人性别
             */
            onConfirmNlhrSex(value) {
                this.sex_nlhr = value.title
                this.body.data.nlhr_xb = value.val
                this.showNlhrPickerSex = false
            },
            /**
             * 选择民族
             * @param value
             */
            onConfirmNation(value) {
                this.showPickerNation = false
                this.mz = value.title
                this.body.data.nlhr_mz = value.val
            },
            /**
             * 传给定制化展示组件基本信息
             */
            sendCustomInfomation() {
                const baseInfoList = [
                    {title: '公安机关', prop: this.informationShowData.deptName},
                    {title: '社会福利机构名称', prop: this.informationShowData.agencyName},
                    {title: '社会福利机构地址', prop: this.informationShowData.agencyAddress},
                    {title: '申请人姓名', prop: this.informationShowData.name},
                    {title: '申请人性别', prop: this.informationShowData.sex},
                    {title: '申请人出生日期', prop: this.informationShowData.sqrCsrq},
                    {title: '申请人身份证号码', prop: this.informationShowData.idNum},
                    {title: '联系电话', prop: this.informationShowData.phone},
                    {title: '联系地址', prop: this.informationShowData.address},
                    {title: '拟落户人姓名', prop: this.informationShowData.nlhrName},
                    {title: '拟落户人性别', prop: this.informationShowData.nlhrSex},
                    {title: '拟落户人民族', prop: this.informationShowData.nlhrNation},
                    {title: '拟落户人出生日期', prop: this.informationShowData.nlhrCsrq},
                    {title: '拟落户人籍贯', prop: this.informationShowData.nlhrJg},
                    {title: '拟落户人与申请人关系', prop: this.informationShowData.relation},
                    {title: '拟落户人地址', prop: this.informationShowData.nlhAddress},
                ]
                this.baseInfoList = baseInfoList
            },
            /**
             * 获取与拟落户人关系
             */
            getRelation() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz_gx_docking`).then(res => {
                    let arr = [];
                    if (res.data.succ = true) {
                        arr = res.data.data;
                    }
                    this.$nextTick(() => {
                        this.relationList = arr
                    })
                }).catch(err => {

                })
            },
            /**
             * 获取民族
             */
            getNation() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.mzlb`).then(res => {
                    if (res.data.succ = true) {
                        this.nationList = res.data.data;
                    }
                }).catch(err => {

                })
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/matter/declare/standard-matter/StandardMatter.less";
</style>
<style>
    .text-danger{
        color:red;
    }
</style>